// Indian Rupee formatting + Marathi digit support
const MR_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

export function toMarathiDigits(s) {
    if (s === null || s === undefined) return s;
    return String(s).replace(/[0-9]/g, (d) => MR_DIGITS[parseInt(d, 10)]);
}

function _currentLang() {
    if (typeof window === "undefined") return "en";
    return window.localStorage?.getItem("wmf_lang") || "en";
}

function _maybeMr(s) {
    return _currentLang() === "mr" ? toMarathiDigits(s) : s;
}

const inrFormatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
});

export function formatINR(n) {
    if (n == null || isNaN(n)) return _maybeMr("₹ 0");
    return _maybeMr(`₹ ${inrFormatter.format(Number(n))}`);
}

export function formatINRCompact(n) {
    if (n == null || isNaN(n)) return _maybeMr("₹ 0");
    const num = Number(n);
    let out;
    if (Math.abs(num) >= 10000000) out = `₹ ${(num / 10000000).toFixed(2)} Cr`;
    else if (Math.abs(num) >= 100000) out = `₹ ${(num / 100000).toFixed(2)} L`;
    else if (Math.abs(num) >= 1000) out = `₹ ${(num / 1000).toFixed(1)}K`;
    else out = `₹ ${inrFormatter.format(num)}`;
    return _maybeMr(out);
}

export function formatDate(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return _maybeMr(
            d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" })
        );
    } catch {
        return iso;
    }
}

export function formatDateTime(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return _maybeMr(
            d.toLocaleString("en-IN", {
                day: "2-digit", month: "short", year: "numeric",
                hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata",
            })
        );
    } catch {
        return iso;
    }
}

export function todayISO() {
    return new Date().toISOString().slice(0, 10);
}

export async function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function waLink(phone, text) {
    const num = String(phone || "").replace(/[^0-9]/g, "");
    const prefixed = num.length === 10 ? `91${num}` : num;
    return `https://wa.me/${prefixed}?text=${encodeURIComponent(text || "")}`;
}


/**
 * Customer / staff visible rename: internal Pigmy account code `PG####` is
 * displayed as `SS####` (Saving Scheme). Non-PG codes (loans, investors,
 * customer codes) pass through unchanged. Safe on null/undefined.
 */
export function displayAcCode(code) {
    const s = String(code || "");
    return s.startsWith("PG") ? "SS" + s.slice(2) : s;
}
